import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enCommon from "./locales/en/common.json";
import enHome from "./locales/en/home.json";
import enAbout from "./locales/en/about.json";
import enPortfolio from "./locales/en/portfolio.json";
import enContact from "./locales/en/contact.json";

import csCommon from "./locales/cs/common.json";
import csHome from "./locales/cs/home.json";
import csAbout from "./locales/cs/about.json";
import csPortfolio from "./locales/cs/portfolio.json";
import csContact from "./locales/cs/contact.json";

export const SUPPORTED_LANGS = ["en", "cs"] as const;
export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

const STORAGE_KEY = "dstejskal:lang";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGS,
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    ns: ["common", "home", "about", "portfolio", "contact"],
    defaultNS: "common",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: STORAGE_KEY,
      caches: ["localStorage"],
    },
    resources: {
      en: {
        common: enCommon,
        home: enHome,
        about: enAbout,
        portfolio: enPortfolio,
        contact: enContact,
      },
      cs: {
        common: csCommon,
        home: csHome,
        about: csAbout,
        portfolio: csPortfolio,
        contact: csContact,
      },
    },
  });

export default i18n;
